import { Button } from "@/components/ui";
import { Tooltip } from "@/components/ui/Tooltip";
import { Mic, Square } from "lucide-react";

interface VoiceRecordButtonProps {
  isRecording: boolean;
  isTranscribing: boolean;
  permissionDenied: boolean;
  onStartRecording: () => void;
  onStopRecording: () => void;
  disabled?: boolean;
}

export const VoiceRecordButton = ({
  isRecording,
  isTranscribing,
  permissionDenied,
  onStartRecording,
  onStopRecording,
  disabled,
}: VoiceRecordButtonProps) => {
  const handleClick = () => {
    if (isRecording) {
      onStopRecording();
    } else {
      onStartRecording();
    }
  };

  const tooltipText = permissionDenied
    ? "Microphone permission denied. Please enable microphone access in your browser settings."
    : isRecording
      ? "Stop recording"
      : "Start recording";

  return (
    <Tooltip tooltipContentText={tooltipText} side="top">
      <Button
        size="sm"
        variant="icon"
        onClick={handleClick}
        disabled={disabled || isTranscribing || permissionDenied}
        data-testid="voice-record-button"
      >
        {isRecording ? (
          <Square className="w-4 h-4 fill-black" />
        ) : (
          <Mic className="w-4 h-4" />
        )}
      </Button>
    </Tooltip>
  );
};
